// src/components/Trust2Section.js
import React from 'react';

const Trust2Section = (props) => {
    const content = props.content || {};
    return (
        <section className="bg-pf-bglight w-full relative flex flex-col items-center justify-center md:p-20 py-6">

            {/* Content */}
            <div className="flex flex-col justify-between md:justify-center items-center w-full h-full z-10 space-y-2">
                <div className="wrapper flex flex-col items-center text-center w-full">
                    <h1 className="text-pf-titleDark md:text-4xl text-3xl md:pb-6 w-10/12 md:w-6/12">
                        {content.trust2.title}
                    </h1>
                    <div className="flex flex-row justify-center items-center space-x-4">
                        {content.trust2.badges.map((item, index) => (
                            <img key={index} src={item.item.src} alt={item.item.alt} className="w-3/12" />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Trust2Section;